import React, { useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import NewButton from '../../../NewComponents/NewButton';
import RejectTranslation from '../../../NewComponents/RejectTranslation';
import ApproveTranslationOwner from '../../../NewComponents/ApproveTranslationOwner';
import { firestore, storage } from '../../../firebase.config';
import { Editor } from 'draft-js';
import { useSpring } from 'react-spring';
import { FileUploaderButton } from '../../../Components/FileUploaderButton';
import { Cross } from 'recharts';
import { NotificationContext } from '../../../Context/NotificationContext';

const OrderTranslation = ({ windowSize, orderInfo, setOrderUpdated, clientRevisionNotes }) => {
  const [translatedFiles, setTranslatedfiles] = useState([]);

  const clientFiles = orderInfo?.files?.filter(file => file.type === "client") || [];
  const { showNotification } = useContext(NotificationContext);
  const [revisionFiles, setRevisionFiles] = useState((orderInfo?.files || []).filter(f => f.type === 'revision' && f.status !== 'revision_history').concat(clientFiles));

  const [open, setOpen] = useState(false);
  const [approveTranslationPopup, setApproveTranslationPopup] = useState(false);
  const [showQualityCheckBtn, setShowQualityCheckBtn] = useState(false);
  const [openRevision, setOpenRevision] = useState(false);
  const [checkReviseFiles, setCheckReviseFiles] = useState([]);
  const revisionModalProps = useSpring({ opacity: openRevision ? 1 : 0, pointerEvents: openRevision ? 'all' : 'none' });

  useEffect(() => {
    const tfiles = orderInfo && orderInfo.files ? orderInfo.files.filter(file => file.type === "translation") : [];
    setTranslatedfiles(tfiles);
  }, [orderInfo])

  useEffect(() => {
    if (!orderInfo?.id) return;
    const unsubscribe = firestore
      .collection("orders")
      .doc(orderInfo.id)
      .onSnapshot((doc) => {
        const data = doc.data();
        if (!data?.files) return;
        const clientSideFiles = data.files.filter((file) => file.type === "client") || [];
        const updatedRevisionFiles = data.files
          .filter((f) => f.type === "revision" && f.status !== "revision_history")
          .concat(clientSideFiles);
        setRevisionFiles(updatedRevisionFiles);
      });
    return () => unsubscribe && unsubscribe();
  }, [orderInfo?.id]);

  useEffect(() => {
    // Show the "Send For Quality Check" button when a translated file is saved
    if (translatedFiles.length > 0) {
      setShowQualityCheckBtn(true);
    } else {
      setShowQualityCheckBtn(false);
    }
  }, [translatedFiles]);

  const rejectFilesHandler = async (files) => {
    if (!files.length) return;

    
    const orderRef = firestore.collection("orders").doc(orderInfo.id);

    try {
      // Update selected files' status to "revision"
      const updatedFiles = orderInfo.files.map(file =>
        files.includes(file) ? { ...file, status: "revision", type: "revision" } : file
      );

      // Update Firestore
      await orderRef.update({
        files: updatedFiles,
      });

      console.log("Files set to revision:", files);
      setOpen(false);
    } catch (error) {
      console.error("Error updating files to revision:", error);
    }
  };

  useEffect(() => {
    setCheckReviseFiles(orderInfo?.files?.find(file => file.type === "revision" && file.status !== 'revision_history'));

  }, [orderInfo]);



  const sendForQualityCheck = async () => {
    if (!checkReviseFiles) {
      const updatedFiles = orderInfo.files.map(file =>
        file.orderStatus && file.orderStatus === "revision" ? { ...file, orderStatus: null } : file
      );
      
      const orderRef = firestore.collection("orders").doc(orderInfo.id);

      try {
        await orderRef.update({
          files: updatedFiles,
          status: "support-review",
        });
        console.log("Order status updated to support-review");
        setOrderUpdated(prev => !prev); // Trigger re-render of parent component
        setShowQualityCheckBtn(false);  // Hide the button after the status is updated
      } catch (error) {
        console.error("Error updating order status to support-review:", error);
      }
    }
  }


  const approveTranslationHandler = async () => {
    
    const orderRef = firestore.collection("orders").doc(orderInfo.id);

    try {
      await orderRef.update({
        status: "user-review",
        supportApproved: true,
      });

      setApproveTranslationPopup(false);
      setOrderUpdated(prev => !prev); // Trigger re-render of parent component
    } catch (error) {
      console.error("Error updating order status to user-review:", error);
    }
  };


  const handleDeleteFile = file => {
    const checkFile = (file1, file2) => {
      if(file1.id && file2.id){
        return file1.id === file2.id;
      }
      if(file1.ref && file2.ref){
        return file1.ref === file2.ref;
      }
    }
    const storageRef = storage.ref();

    if (file.ref && (file.status === "complete" || file.timestamp)) {
      const fileRef = storageRef.child(file.ref);
      setRevisionFiles((f) =>
        f.map((mFile) =>
          mFile.name === file.name && checkFile(mFile, file)
            ? { ...mFile, status: "revision_history" }
            : mFile
        )
      );

      Promise.resolve().then(function () {
        const updatedFiles = orderInfo.files.map((mFile) =>
          checkFile(mFile, file) ? { ...mFile, status: "revision_history" } : mFile
        );
        firestore.collection("orders").doc(orderInfo.id).update({
          files: updatedFiles,
        });
        setRevisionFiles((f) =>
          f.map((mFile) =>
            checkFile(mFile, file) ? { ...mFile, status: "revision_history" } : mFile
          )
        );
        }).catch(function (error) {
          showNotification(
            "Error deleting the file.",
            "There was an error deleting the file " +
              file.name +
              ". Please, try again.",
            "error"
          );
        });
    } else if (file.status === "failed") {
      setRevisionFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    } else {
      file.task.cancel();
      setRevisionFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    }
    }

    
  return (
    <>
      {
        showQualityCheckBtn && <div className="orderSummary flex flex-col gap-2">
          <h2 className="orderSummaryTitle">Translation</h2>

          {
            orderInfo.status === "support-review" && <>
              <NewButton
                text="Approve Translation"
                onClick={() => setApproveTranslationPopup(true)}
                icon={false}
                width='100%'
                disabled={orderInfo.certified ? translatedFiles.filter(f => f.format === "application/vnd.openxmlformats-officedocument.wordprocessingml.document").length === 0 
                  || translatedFiles.filter(f => f.format === "application/pdf").length === 0 : translatedFiles.filter(f => f.format === "application/vnd.openxmlformats-officedocument.wordprocessingml.document").length === 0 
                }
              />
              <NewButton
                text="Reject Translation"
                onClick={() => setOpen(true)}
                back
                icon={false}
                whiteBtn
                width='100%'
              />
              {
                approveTranslationPopup && (
                  <ApproveTranslationOwner
                    onClick={approveTranslationHandler}
                    onCancelClick={() => setApproveTranslationPopup(false)}

                  />
                )
              }

              {open && (
                <RejectTranslation
                  files={translatedFiles}
                  onCancelClick={() => setOpen(false)}
                  onRejectClick={rejectFilesHandler}
                />
              )}
            </>
          }

          {
            orderInfo.status === "revision" && <>
              {checkReviseFiles && <p className='revisionTextWarning'>Revision file must be deleted and replaced with a corrected version </p>}
              <NewButton
                text="Send For Quality Check"
                onClick={sendForQualityCheck}
                icon={false}
                width='100%'
                disabled={checkReviseFiles}
              />
            </>
          }
          {showQualityCheckBtn && orderInfo.status !== "support-review" && orderInfo.status !== "revision" && (
            <NewButton
              text="Send For Quality Check"
              onClick={sendForQualityCheck}
              icon={false}
              width='100%'
              disabled={checkReviseFiles}
            />
          )}


        </div>
      }
      {
        orderInfo.status === "revision" && <div className="orderSummary">
          <h2 className="orderSummaryTitle">Revision Request</h2>

          {
            orderInfo.status === "revision" && <>
              <NewButton
                text="See Revision Request"
                onClick={() => setOpenRevision(true)}
                icon={false}
                width='100%'
              />
            </>
          }
        </div>
      }
      {openRevision && 
        ReactDOM.createPortal(
          <div style={revisionModalProps} className="orderRevisionModalBg" onClick={() => setOpenRevision(false)}>
            <div style={{ justifyContent: 'flex-start' ,...revisionModalProps }} className="orderRevisionModalOuter" onClick={(e) => e.stopPropagation()}>
              <div 
                role="modal-container" 
                className="flex flex-col gap-5 w-full"
              >
                <div role="modal-header" className="singleQuoteMainPrimaryFilesTitle" 
                  style={{ 
                    marginTop: 0,
                    padding: 0,
                    fontSize: '24px',
                    color: '#030F23',
                    lineHeight: '140%',
                    letterSpacing: '0.24px',
                  }}
                >
                  <span>Revision Notes</span>
                  <img
                    src={require('../../../assets/Cross M.png')}
                    alt="close-icon"
                    className="size-5 cursor-pointer"
                    onClick={() => setOpenRevision(false)}
                  />
                </div>
                {clientRevisionNotes.getCurrentContent().getPlainText() !== '' &&
                <div style={{ gap:'16px', marginBottom : '0px' }}  className="singleTranslationNotesContainer">
                  <h2 className="yourNotesText">Client's Revision Notes</h2>
                  <div style={{ borderRadius:'6px', minHeight:'20vh', maxHeight : '200px', overflow : 'auto' }} className="singleTranslationRichTextEditor no-scrollbar adminSeeRevisionRequestFiles">
                    <Editor
                      editorState={clientRevisionNotes}
                      readOnly
                    />
                  </div>
                </div>}
              </div>
              <div className="yourNotesText">Revision Files</div>
              {orderInfo && orderInfo.files && <div style={{maxHeight: '150px', overflow: 'auto', marginTop : '0px' , boxShadow: 'inset 0 -8px 8px -8px rgba(0,0,0,0.1)'}} className="quoteDetailsFileUploaderContainer no-scrollbar adminSeeRevisionRequestFiles">
                <FileUploaderButton display backend text="Add Files" files={revisionFiles} showDownloadButton={true} showDeleteBtn={true} handleDeleteFile={handleDeleteFile}/>
              </div>
              }
            </div>
          </div>,
          document.getElementById('admin-seeRevisionModal')
        )
      }
    </>
  );
};

export default OrderTranslation;
